var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"sidebar__main-nav__links-list list-unstyled d-flex flex-column"},_vm._l((_vm.links),function(link,index){return _c('SidebarItem',{key:link + index,attrs:{"item":link,"parentOpen":_vm.isOpen}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }